<template>
  <v-container class="py-0 px-6">
        <v-row>
          <v-spacer></v-spacer>
          <span v-if="hasLotesValidos && showLotes">
              <v-tooltip right >
                <template v-slot:activator="{on, attrs}">
                  <v-btn
                  color="primary" 
                  icon
                  small
                  @click=modalVideoNotas()
                  v-bind="attrs"
                  v-on="on"  
                  >
                <v-icon small>fa-regular fa-life-ring</v-icon>
              </v-btn>
                </template>
                <span class="px-3 py-1 ma-0"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    ">Ajuda: Como adicionar documentos fiscais e associá-los aos lotes </span>
              </v-tooltip>
            </span>
          <v-btn
            small
            v-if="hasLotesValidos && showLotes"
            outlined
            height="30px"
            color="primary"
            depressed
            class="px-2 ml-2"
            @click="showNotas(cronogramadata)"
            >{{ parametros && parametros.FAT_TIPO_TITULO ? 'Notas Fiscais e títulos' : 'Notas Fiscais'}}</v-btn>
            <!-- ANTIGA NOTA FISCAL -->
            <!-- @click="showNotas(cronogramadata.id)" -->
          <v-btn
          
            v-if="!showLotes"
            small
            outlined
            height="30px"
            color="primary"
            depressed
            class="px-2 ml-2"
            @click="getLotes()"
            >Lotes</v-btn>
            <!-- v-show="showDadosEntrega" -->
          <v-btn
           small
            outlined
            height="30px"
            color="primary"
            depressed
            class="px-2 ml-2"
            @click="showDadosEntregaDialog(cronogramadata.id, dadosEntregaData)"
            >Dados da Entrega</v-btn>
          <div v-show="cronogramadata.status!='F'" v-if="userData.PermissaoAcoes.faturamento.includes('deletecronograma')">
            <v-btn
             small
              v-if="userData.Id = cronogramadata.owner_id || userData.Permissao.faturamento.length > 2"
              outlined
              height="30px"
              color="primary"
              class="px-2 ml-2"
              depressed
              :disabled="lotesFilter.length > 0"
              @click="deleteCronogramaConfirm(cronogramadata)"
              >Excluir cronograma</v-btn>
            <v-tooltip v-else center bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                 small
                outlined
                color="rgb(151 151 151 / 58%)"
                height="30px"
                class="px-2 ml-2"
                depressed
                v-bind="attrs"
                v-on="on"
                >Excluir cronograma</v-btn>
              </template>
              <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                Você não possui permissão para executar esta ação.
              </span>
            </v-tooltip>
          </div>
          <div v-if="userData.PermissaoAcoes.faturamento.includes('updatecronograma')">
            <!--v-show="cronogramadata.status!='F' || cronogramadata.grupo_economico == 1" -->
            <v-btn
            v-if="userData.Id = cronogramadata.owner_id || userData.Permissao.faturamento.length > 2"
             small
            height="30px"
            color="primary"
            :outlined='aguardandoConclusao'
            depressed
            class="px-2 ml-2"
            @click="editCronograma()"
            >Editar cronograma</v-btn>
            <v-tooltip v-else center bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                 small
                outlined
                color="rgb(151 151 151 / 58%)"
                height="30px"
                class="px-2 ml-2"
                depressed
                v-bind="attrs"
                v-on="on"
                >Editar cronograma</v-btn>
              </template>
              <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                Você não possui permissão para executar esta ação.
              </span>
            </v-tooltip>
          </div>
          <div v-show="cronogramadata.status!='F'" v-if="userData.PermissaoAcoes.faturamento.includes('closecronograma') && aguardandoConclusao">
            <v-btn
            v-if="userData.Id==cronogramadata.owner_id || userData.Permissao.faturamento.length > 2"
             small
            height="30px"
            color="primary"
            depressed
            class="px-2 ml-2"
            @click="closeCronogramaConfirm"
            >Concluir cronograma</v-btn>
            <v-tooltip v-else center bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                 small
                outlined
                color="rgb(151 151 151 / 58%)"
                height="30px"
                class="px-2 ml-2"
                depressed
                v-bind="attrs"
                v-on="on"
                >Concluir cronograma</v-btn>
              </template>
              <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                Você não possui permissão para executar esta ação.
              </span>
            </v-tooltip>
          </div>
        </v-row>
    <v-row class="mx-0 my-2">
      <v-col class="pa-0" cols="12">
        <h1>Dados do cronograma<span>
              <v-tooltip right >
                <template v-slot:activator="{on, attrs}">
                  <v-btn
                  color="primary" 
                  icon
                  small
                  @click=modalVideo()
                  v-bind="attrs"
                  v-on="on"  
                  >
                <v-icon small>fa-regular fa-life-ring</v-icon>
              </v-btn>
                </template>
                <span class="px-3 py-1 ma-0"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    ">Ajuda: Entendendo a evolução do envio de faturamento </span>
              </v-tooltip>
            </span></h1>
        <p class="mb-0">Visualize e edite os dados do cronograma e acompanhe o seu status.</p>
      </v-col>
    </v-row>
    <v-row class="px-1">
      <v-col class="py-0" cols="12">
        <CronogramaInfo :info="cronogramadata" v-if="cronoLoaded"/>
      </v-col>
      <v-col class="py-0 px-15" cols="12">
        <CronogramaProgressao :info="cronogramadata" :parameter="cronogramadata.config" v-if="cronoLoaded"/>
      </v-col>
      <v-col class="px-4" cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <!-- <v-row class="px-2" v-if="showDadosEntregaInfo">
      <v-col class="py-0" cols="12">
        <CronogramaDadosEntregaInfo
          :info="dadosEntregaData"
          :showDadosEntregaDialog="(info)=>showDadosEntregaDialog(cronogramadata.id, info)"
          :getDocument="(opts) => getDocument(opts)"
          :userData="userData"
        />
      </v-col>
      <v-col class="px-4" cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row> -->
    <v-row class="px-2" id="notas">
      <v-col class="py-0" cols="12">
        <CronogramaLoteFilter
          :info="cronogramadata"
          v-show="showLotes"
          :getList="(formData)=>getLotes(formData)"
          :total_lotes="total_lotes"
          :userData="userData"
          :showOpen="(str) => modalShow(str)"
          :hasLotesValidos="hasLotesValidos"
          :filterList="(formData) => filterList(formData)"
          :parameter="cronogramaConfig"
          :refresh="() => {updateCronogramaData(), getLotes()}"
          :protocoloEmMassa="() => openProtocoloEmMassa()"
          :protocoloEmMassaBtn="protocoloEmMassaBtn"
          :protocoloAlocado="protocoloAlocado"
          :userProtocoloAlocado="userProtocoloAlocado"
          :downloadCapalote="() => downloadCapalote()"
          :downloadShow="lotesFilter.filter(el => el.capa_lote_doc_id != null).length > 0"
          :downloadValid="lotesSelecionados.filter(el => el.capa_lote_doc_id != null).length > 1"
          :lotesSelectList="lotesSelecionados"
          :relaGuias="(t) => {relaGuia(t)}"
        />  
        <NotasAssociadas
          v-if="!showLotes"
          :parametros="parametros"
        />  
        <CronogramaModalAddDadosEntrega
          :dadosEntregaData="dadosEntregaData"
          :showOpen="showDadosEntregaForm"
          :showClose="(val) => showCloseDadosEntregaDialog(val)"
          :sendForm="(formData, file) => saveDadosEntrega(formData, file)"
          :getDocument="(opts) => getDocument(opts)"
          :userData="userData"
          :parameter="cronogramadata"
        />
      </v-col>
      <!-- <v-col class="text-right px-2 py-0" cols="12">
        <v-btn
          small
          outlined
          height="30px"
          color="primary"
          depressed
          class="px-2 ml-2"
          @click="protocoloEmMassa = true"
        >Protocolo em massa</v-btn>
      </v-col> -->
      <v-col class="px-2" cols="12">
         <CronogramaLoteList
          v-show="showLotes"
          :list="lotesFilter"
          :selected="(item) => selectLote(item)"
          :cronogramaConfig="cronogramaConfig"
          :fechado="fechado"
          :resetData="resetSelect"
          :getLotes="() => getLotes()"
          :getDetalhesCronograma="() => updateCronogramaData()"
          :getDocument="(opts) => getDocument(opts)"
          :dadosCronograma="cronogramadata"
          :userData="userData"
        />
      </v-col>
    </v-row>
    <AssociarNotaFiscalDlg
      :dialog="dialog"
      :list="notas_list"
      :sendForm="(formData) => sendForm(formData)"
      :cronogramaId="cronogramadata? cronogramadata.id : null"
    />
    <CronogramaModalAddLote
      :dialog="showUpload"
      :close="() => { updateCronogramaData(), getLotes()}"
      :grupoEconomico='grupoEconomico'
      :userData='userData'
      :dadosCronograma='cronogramadata'
      :lotesPendentes="false"
      :multioperadoras_list="multioperadoras_list"
    />
    <ProtocoloEmMassa
      :dialog="protocoloEmMassa"
      :close="() => desalocaProtocolo()"
      :data="cronogramadata"
      :lotesIds="lotesIdsProtocolo"
    />
    <RelacaoGuiasDlg
      :dialog="showRelacao"
      :close="() => {showRelacao = false, primeiraBusca = true}"
      :relacao="relacaoList"
      />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import CronogramaInfo from '@/components/faturamento/dados_cronograma/CronogramaInfo'
import CronogramaProgressao from '@/components/faturamento/dados_cronograma/CronogramaProgressao'
import CronogramaLoteFilter from '@/components/faturamento/dados_cronograma/CronogramaLoteFilter'
import CronogramaLoteList from '@/components/faturamento/dados_cronograma/CronogramaLoteList'
import CronogramaModalAddLote from '@/components/faturamento/dados_cronograma/CronogramaModalAddLote'
import NotasAssociadas from './notas_fiscais/NotasAssociadas'
import CronogramaModalAddDadosEntrega from '@/components/faturamento/dados_cronograma/CronogramaModalAddDadosEntrega'
import ProtocoloEmMassa from './dados_cronograma/ProtocoloEmMassaDlg.vue'
// import CronogramaDadosEntregaInfo from '@/components/faturamento/dados_cronograma/CronogramaDadosEntregaInfo'
import AssociarNotaFiscalDlg from './notas_fiscais/AssociarNotaFiscalDlg'
import RelacaoGuiasDlg from '@/components/faturamento/dados_cronograma/RelacaoGuiasDlg'
export default {
  components: {
    CronogramaInfo,
    CronogramaProgressao,
    CronogramaLoteFilter,
    CronogramaLoteList,
    CronogramaModalAddLote,
    NotasAssociadas,
    CronogramaModalAddDadosEntrega,
    ProtocoloEmMassa,
    // CronogramaDadosEntregaInfo,
    AssociarNotaFiscalDlg,
    RelacaoGuiasDlg
  },
  data() {
    return {
      aguardandoConclusao: false,
      cronogramaConfig: {},
      cronogramadata: {
        arq_vl_calculado: null,
        descricao: null,
        dt_faturamento: null,
        dt_prev_vencimento: null,
        id: null,
        login_prestador: null,
        oper_nome: null,
        owner_username: null,
        prest_nome: null,
        prestador_id:null,
        status: null,
        tipo_guia: null,
        qt_arq: null,
        qt_arq_critica: null,
        vl_prev_faturamento: null
      },
      cronogramaId: null,
      cronoLoaded: false,
      dadosEntregaData: {
         id: null,
         empresa: null,
         dt_envio: null,
         codigo_rastreio: null,
         observacao: null
      },
      dialog: false,
      hasLotesValidos: true,
      lotes_list: [],
      lotesId: [],
      lotesFilter: [],
      lotesSelecionados: [],
      notas_list: [],
      fechado: null,
      lotesIdsProtocolo: [],
      multioperadoras_list: [],
      parametros: null,
      //protocoloAlocado: false,
      protocoloEmMassa: false,
      protocoloEmMassaBtn: false,
      resetSelect: false,
      showLotes: true,
      showDadosEntrega: false,
      showDadosEntregaForm: false,
      showDadosEntregaInfo: false,
      showNota: false,
      showUpload: false,
      total_lotes: null,
      userDisabled: true,
      userProtocoloAlocado: '',
      showRelacao: false,
      relacaoList: null,
    }
  },
  mounted() {
    this.getDetalhesCronograma(this.$route.params).then(resp => { 
      this.cronogramadata = resp
      this.cronogramadata.grupo_economico= this.grupoEconomico 
      this.cronoLoaded= true
      this.total_lotes = resp.total
      this.aguardandoConclusao = resp.capa_lote_status == 1 ? true : false
      if (
        this.cronogramadata.analisados_operadora_status==1
        && this.cronogramadata.em_validacao_status==0
        && this.cronogramadata.validados_status==0
        && this.cronogramadata.em_transmissao_status==0
        && this.cronogramadata.transmitido_status==0
        && this.cronogramadata.situacao_protocolo_status==0
        && this.cronogramadata.capa_lote_status==0
      ){
        this.showDadosEntrega = true
      }
      else {
        this.showDadosEntrega = false
      }
      this.cronogramaConfig = this.cronogramadata.config != null? this.cronogramadata.config : {}
      this.getDadosEntrega()
      this.getLotes()
      this.getParametrizacao()
    })
  },
  computed:{
    ...mapState({
      grupoEconomico: state => state.permissions.grupoEconomico,
      // prestadorCronograma: state => state.faturamento.prestadorCronograma,
      userData: (state) => state.userData.userData,
    }),
    protocoloAlocado(){
      let Alocados = false
      if(this.parametros && this.parametros.FAT_ACEITA_XML_INVALIDO){
        Alocados = this.lotesSelecionados.filter(el => (el.etapa >=20 || el.etapa >= 40) && (el.username_editing == this.userData.UserName || el.username_editing == null|| el.username_editing == '') && el.env_op_tem_erro	== 0).length > 1
      }
      else {
        Alocados = this.lotesSelecionados.filter(el => ((el.etapa >=20 && el.proc_trd_tem_erro == 0) || el.etapa >= 40) && (el.username_editing == this.userData.UserName || el.username_editing == null|| el.username_editing == '') && el.env_op_tem_erro	== 0).length > 1
      }
      return Alocados
    }
  },
  methods: {
    ...mapActions({
      "getDetalhesCronograma":"faturamento/getDetalhesCronograma",
      "closeCronograma":"faturamento/closeCronograma",
      "getDocument":"documents/getDocument",
    }),
    downloadCapalote() {
      let docIds_capaLote = this.lotesSelecionados.filter(el => el.capa_lote_doc_id != null).map(el => el.capa_lote_doc_id)
      let noCapaLote = this.lotesSelecionados.filter(el => el.capa_lote_doc_id == null).map(el => el.arq_nome)
      if (noCapaLote.length) {
        let paramModal = {
          type: "warning",
          title: "Seleção sem capa de lote!",
          message: `Os lotes ${noCapaLote.join(", ")}, não possuem capas disponíveis.<br> Serão disponibilizadas nesta seleção as capas obtidas.`,
          callback: () => this.downloadZip(docIds_capaLote),
          btConfirm: { name: "Ok", show: true, color: 'warning'},
          btCancel: { name: "Não", show: false },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        this.downloadZip(docIds_capaLote)
      }
    },
    downloadZip(ids) {
      let modulo = "Portal"
      let acao = "getdocumentzip"
      let Payload = {grupo_economico: 1, doc_ids: ids}
      this.$store.commit('showLoader', { circle: true })
      this.$store.dispatch("documents/getDocumentPost", { Payload, acao, callback: ()=> setTimeout(()=>{this.resetSelected(); this.$store.commit('hideLoader')}, 200), modulo }, {root:true})
    },
    getParametrizacao(){
            let { operadora_ans_id, prestador_id } = this.cronogramadata
            let opts = {
            query: [
                {
                Modulo: "Portal",
                Acao: "getparametrizacoes",
                Payload: {
                    grupo_economico: this.grupoEconomico,
                    operadora_ans_id, 
                    prestador_id
                  },
                },
            ],
            noLoader: true,
            };
            this.$store.dispatch("request/doRequest", opts).then(resp => {
              this.parametros = resp.parametros
              if(this.cronogramaConfig != "" && this.cronogramaConfig != null)
                this.cronogramaConfig = resp.parametros
              this.cronogramaConfig.FAT_EDITA_GUIA_VALIDA = resp.parametros.FAT_EDITA_GUIA_VALIDA
              return resp.parametros
              })
        },
    updateCronogramaData(){
      this.getDetalhesCronograma(this.$route.params).then(resp => {
        this.aguardandoConclusao = resp.capa_lote_status == 1 ? true : false
        this.cronogramadata = resp
        this.cronogramadata.grupo_economico= this.grupoEconomico 
        this.cronoLoaded = true
        this.total_lotes = resp.total
      })
    },
    closeCronogramaConfirm(){
      let message = []
      if(!!this.cronogramadata.config && (this.cronogramadata.config.FAT_DADOS_ENTREGA_OBRIGATORIO || this.cronogramadata.config.FAT_NOTA_FISCAL_OBRIGATORIO)) {
        if(this.cronogramadata.config.FAT_DADOS_ENTREGA_OBRIGATORIO && this.dadosEntregaData.id==null){
          message.push(" é obrigatório o cadastro dos dados de entrega")
        }
        if(this.cronogramadata.config.FAT_NOTA_FISCAL_OBRIGATORIO && this.lotes_list.find(lote =>lote.arq_nfs==null)){
          message.push(" todos os lotes tem de estar associados a uma nota fiscal")
        }
        if(message.length) {
          message = message.join(' e ')
          message = "Para poder concluir o cronograma" + message + '.'

          let paramModal = {
            type: "error",
            title: "Atenção!",
            message: message,
            callback: null,
            btConfirm: { name: "Ok", show: true },
            btCancel: { name: "Cancelar", show: false },
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          return
        }
      }

      
      if(this.cronogramadata.vl_prev_faturamento != this.cronogramadata.arq_vl_calculado){
        message.push("O valor previsto difere do importado nos lotes.")
      }
      if(new Date().getTime() < new Date(this.cronogramadata.dt_faturamento).getTime()){
        message.push("A data de faturamento é superior ao dia de hoje.")
      }
      message = message.join('<br>')
      let payload = Object.assign({grupo_economico: this.grupoEconomico}, this.cronogramadata)
      if(message.length){
         let paramModal = {
          type: "warning",
          title: "Deseja concluir este cronograma?",
          message: message,
          callback: () => this.closeCrono(payload),
          btConfirm: { name: "Concluir", show: true, color: 'warning'},
          btCancel: { name: "Não", show: true },
        };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);  
      } else {
        this.closeCrono(payload)
      }
      
    },
    modalVideo(){
      let paramModal = {
          codigo: "754272445",
          title: "Entendendo a evolução do envio de faturamento",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },
    modalVideoNotas(){
      let paramModal = {
          codigo: "754272649",
          title: "Como adicionar documentos fiscais e associá-los aos lotes",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },
    closeCrono(payload){
      this.closeCronograma(payload).then(response =>{
        if(response.sucesso == true){
          let paramModal = {
              type: "success",
              title: "Sucesso",
              message: response.mensagem,
              callback: ()=> {this.updateCronogramaData(); this.getLotes()},
              btConfirm: { name: "Ok", show: true },
              btCancel: { name: "Não", show: false },
            };
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        }
      })

    },
    deleteCronogramaConfirm(selectedItem) {
      let paramModal = {
        type: "error",
        title: "Exluir cronograma?",
        message: 'Ao excluir, este cronograma não estará mais disponível.<br>Essa alteração <b>não</b> poderá ser desfeita.',
        callback: () => this.deleteCronograma(selectedItem),
        btConfirm: { name: "Excluir", show: true, color: "error" },
        btCancel: { name: "Não", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    deleteCronograma(selectedItem) {
      let obj = {
        query: [
          {
            Modulo: "faturamento",
            Acao: "deletecronograma",
            Payload: {
              id: selectedItem.id,
              grupo_economico: this.grupoEconomico,
              dt_alteracao: selectedItem.dt_alteracao,
            },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.erros.length) {
          this.$store.commit("hideLoader")
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso",
          message: response.mensagem,
          callback: ()=> this.$router.go(-1),
          btConfirm: { name: "Ok", show: true },
          btCancel: { name: "Não", show: false },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },
    editCronograma() {
      let id = this.cronogramadata.id
      let url  = '/faturamento/cronogramas/cadastrocronograma/'+id
      this.$router.push(url)
    },
    showNotas(crono) {
      //# NOVO COMPONENTE DE NOTA FISCAL#//
      let opts = { dados: crono , parametros: this.parametros}
     
      this.$store.commit("notasFiscais/showNotas", opts);

      //# ANTIGA NOTA FISCAL #//

      // this.showLotes = false
      // this.cronogramaId = id
      // this.scrollTo('notas')
    },
    scrollTo(anchor) {
       let el = document.getElementById(anchor)
        if (el) {
          window.scrollTo(0, el.offsetTop+100)
        }
    },
    //Funções dos dados de entrega
    showDadosEntregaDialog(id) {
      this.showDadosEntregaForm = true
      this.cronogramaId = id
    },
    showCloseDadosEntregaDialog(val) {
      this.showDadosEntregaForm = val
    },
    saveDadosEntrega(formData, file) {
      formData.cronograma_id = this.cronogramaId
      formData.grupo_economico = this.grupoEconomico
      let acao = formData.id ? "updatedadosentrega" : "adddadosentrega"
      let payload = JSON.stringify(formData)
      var data = new FormData();
      data.append('Modulo', 'Faturamento');
      data.append('Acao', acao);
      data.append('Payload', payload);
      data.append('File', file);
      
      this.$store.dispatch("request/sendFile", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        } 
        this.showCloseDadosEntregaDialog(false)
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            // Buscar novos dados de entrega
            this.getDadosEntrega()
            // let opts = {id:this.cronogramaId}
          },
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    getDadosEntrega() {
      let grupo_economico = this.grupoEconomico
      let cronograma_id = this.cronogramadata.id
      let payload = {grupo_economico, cronograma_id}
      let obj = {query:[ {acao: 'getDadosEntrega', modulo: 'Faturamento', payload: payload}]}
      this.$store.dispatch("request/doRequest",obj, {root: true}).then(resp => {
        if (resp && resp.id != 0) {
          this.showDadosEntregaInfo = true
          this.dadosEntregaData = resp
        } else {
          this.showDadosEntregaInfo = false
        }
        // this.lotes_list = resp.dados
        // this.cronogramadata.total_arquivos = resp.total
        // this.total_lotes = (resp.total == 0 && this.total_lotes == 0)? null : resp.total
      })
    },
    //Fim das funções dos dados de entrega
    sendFile(file){

      let grupo_economico = this.grupoEconomico
      let { cronograma_id, prestador_id, operadora_ans_id } = this.cronogramadata
      let owner_id = this.userData.Id
      let owner_username = this.userData.UserName
      let payload = JSON.stringify({ grupo_economico, cronograma_id, prestador_id, operadora_ans_id, owner_id, owner_username})

      var data = new FormData();
      data.append('Modulo', 'Faturamento');
      data.append('Acao', 'addlote');
      data.append('Payload', payload);
      data.append('File', file);

      this.$store.dispatch("request/sendFile", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.$store.dispatch("request/doRequest",{acao: 'getlotes', modulo: 'faturamento', payload:{ grupo_economico, cronograma_id}}, {root: true}).then(resp => {
              this.cronogramadata.qt_arq = resp.total
              this.total_lotes = resp.total
              })
            
          },
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    getLotes(formData) {
      this.showLotes = true
      this.showUpload = false
      let grupo_economico = this.grupoEconomico
      let cronograma_id = this.cronogramadata.id != 0? this.cronogramadata.id : this.$route.params
      let payload = Object.assign({ grupo_economico, cronograma_id}, formData)
      let obj = {query:[ {acao: 'getlotes', modulo: 'Faturamento', payload: payload}]}
      this.$store.dispatch("request/doRequest",obj, {root: true}).then(resp => {
        this.lotes_list = resp && resp.dados ? resp.dados : []
        if(this.parametros && this.parametros.FAT_ACEITA_XML_INVALIDO){
          this.hasLotesValidos = this.lotes_list? this.lotes_list.filter(el=> el.etapa >= 20).length > 0 : false
        }
        else 
        {
          this.hasLotesValidos = this.lotes_list? this.lotes_list.filter(el=> el.etapa >= 20 && (el.proc_trd_tem_erro==0 ||(el.proc_trd_tem_erro==1 && el.fl_tratado == true))).length > 0 : false
        }
        // this.aguardandoConclusao = this.lotes_list? this.lotes_list.filter(el=> el.etapa < 70 ).length == 0 : false
        this.cronogramadata.qt_arq = resp.total
        this.total_lotes = (resp.total == 0 && this.total_lotes == 0)? null : resp.total
        this.fechado = this.cronogramadata.status
        this.resetSelected()
        this.filterList(this.lotes_list)
        this.scrollTo('notas')
      })
    },
    filterList(formData) {
      // this.filter = formData
      let list = Array.from(this.lotes_list)
      let newList = []
      if (formData && list.length) {
        newList = list.reduce((arr, item) => {
          let matchType = 
          formData.etapa == 1 ?item.etapa == 10 && item.proc_trd_tem_erro == 0 :
          formData.etapa == 2 ?item.etapa == 20 && item.proc_trd_tem_erro == 0 :
          formData.etapa == 3 ?item.etapa >= 10 && item.etapa <= 20 && item.proc_trd_tem_erro == 1 :
          formData.etapa == 4 ?item.etapa > 20 && item.etapa < 40 :
          formData.etapa == 5 ?item.etapa >= 40 && item.etapa < 70 && item.env_op_tem_erro == 0 :
          formData.etapa == 6 ?item.etapa >= 60 && item.env_op_tem_erro == 1 :
          formData.etapa == 7 ?item.etapa >= 70 && item.capa_lote_doc_id == null && item.env_op_tem_erro == 0 && (!!this.cronogramadata.config && !this.cronogramadata.config.FAT_CAPA_LOTE_OBRIGATORIO) :
          formData.etapa == 8 ?item.etapa >= 70 && item.capa_lote_doc_id == null && item.env_op_tem_erro == 0 && (!!this.cronogramadata.config && this.cronogramadata.config.FAT_CAPA_LOTE_OBRIGATORIO) :
          formData.etapa == 9 ?item.etapa >= 70 && item.capa_lote_doc_id != null && item.env_op_tem_erro == 0 : formData.etapa == null
          let regex = formData.search ? new RegExp(formData.search, "gi") : null
          let matchSearch = regex ? item.arq_nome.match(regex) != null ||
          ( item.arq_numero_lote && item.arq_numero_lote.match(regex) != null ||
          item.arq_identificador_prestador && item.arq_identificador_prestador.match(regex) != null || 
          item.env_op_protocolo && item.env_op_protocolo.match(regex) != null ||
          item.arq_nfs && item.arq_nfs.filter(el => el.match(regex))[0] != null ||
          item.tipo_guia_descricao && item.tipo_guia_descricao.match(regex) != null ): true
          if(matchSearch && matchType) { arr.push(item) }
          return arr
        }, [])
      }
      this.lotesFilter = newList
      if(this.parametros && this.parametros.FAT_ACEITA_XML_INVALIDO){
        this.protocoloEmMassaBtn = newList.filter(el => ((el.etapa >=20) || el.etapa >= 40) && (el.username_editing == this.userData.UserName || el.username_editing == null|| el.username_editing == '') && el.env_op_tem_erro == 0).length > 1
      }
      else 
      {
        this.protocoloEmMassaBtn = newList.filter(el => ((el.etapa >=20 && el.proc_trd_tem_erro == 0) || el.etapa >= 40) && (el.username_editing == this.userData.UserName || el.username_editing == null|| el.username_editing == '') && el.env_op_tem_erro == 0).length > 1
      }
      // this.protocoloAlocado = newList.filter(el => ((el.etapa >= 20 && el.proc_trd_tem_erro == 0) || el.etapa >= 40) && (el.protocolo_editing_user == this.userData.UserName || el.protocolo_editing_user == null)).length > 1
      // if (!this.protocoloAlocado) {
      //   this.userProtocoloAlocado = newList.filter(el => el.protocolo_editing_user != null)[0].protocolo_editing_user
      // }
      this.resetSelected()
    },
    modalShow(str) {
      if(str == "liberar_envio"){
        let hasLoteValido = this.lotes_list.filter(el=> el.etapa == 20 && !el.proc_trd_tem_erro)
        if(hasLoteValido.length){
          this.confirmLiberacaoLotes()
        } else {
          let paramModal = {
          type: "error",
          title: "Atenção!",
          message: "Não existem lotes válidos para serem liberados para o envio à operadora.",
          callback: null,
          btConfirm: { name: "Fechar", show: true },
          btCancel: { show: false }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        }
        return
      }
      if (str == 'add_lote') {
        if(this.cronogramaConfig && this.cronogramaConfig.CG_MULTIOPERADORAS && this.cronogramaConfig.CG_MULTIOPERADORAS_ANS)
        {
          let obj = {
            query: [{ 
              Modulo: "Portal",
              Acao: "getoperadorasansregistros",
              Payload: {
                grupo_economico: this.grupoEconomico,
                operadora_ans_id: this.cronogramadata.operadora_ans_id,
                prestador_id: this.cronogramadata.prestador_id
              }
            }],
          }
          this.$store.dispatch("request/doRequest", obj).then(response => {
            console.log(response)
            this.multioperadoras_list = response.dados;
            this.showUpload = true;
          })
        } else {
          this.multioperadoras_list = [];
          this.showUpload = true;
        }
      }
      // ASSOCIAR NOTA
      if (str == 'associar_nota') {
        this.openModalAssociarNota()
      }
      // DELETAR NOTA
      if (str == 'delete_lote') {
        this.openModalDeleteLote()
      }
    },
    getNotas(loteId) {
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "getnotasfiscais",
          Payload: {
            grupo_economico: this.grupoEconomico,
            cronograma_id: this.cronogramadata.id,
            id_lote: loteId ?loteId :null 
          }
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.notas_list = response.dados
        this.dialog = true
        this.scrollTo('notas')
      })
    },
    sendForm(formData) {
      if (formData != null) {
        let list = formData.reduce((arr, item) => {
          let ids = item.is_associado == 1 ?item.id :null
          if (ids) { arr.push(ids) } return arr
        },[]) 
        this.associarNota(list, this.lotesId)
      } else {
        this.dialog = false
        this.resetSelect = true
      }
    },
    openModalAssociarNota(){
      let paramModal = {
        type: "error",
          btConfirm: { name: "Fechar", show: true },
          btCancel: { name: 'Cancelar', show: false },
          textForm: {  show: false }
        }
      if(!this.lotesSelecionados || this.lotesSelecionados.length == 0) {
        paramModal.title = "Selecione ao menos um lote para associar nota fiscal"
        paramModal.message = "Você pode associar uma mesma nota <br/> a um ou vários lotes."
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        let hasLotesComNotas = this.lotesSelecionados.filter(el => el.arq_nfs && el.arq_nfs.length > 0).length > 0
        if (hasLotesComNotas && this.lotesSelecionados.length > 1) {
          paramModal.title = "Atenção!"
          paramModal.message = "Existe um ou mais lotes com notas já associadas, <br/> estes lotes devem ser editados individualmente."
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        } else {
          this.lotesId = this.lotesSelecionados.map(el => ({lote_id: el.id, dt_alteracao: el.nota_fiscal_dt_alteracao}))
          this.getNotas(this.lotesId[0].lote_id)
        }
      }
    },
    openModalDeleteLote() {
      let id = this.lotesSelecionados.map(el => ({id:el.id, dt_alteracao: el.dt_alteracao}))
      let paramModal = {
        type: "error",
        btConfirm: { name: "Ok", show: true },
        btCancel: { name: 'Cancelar', show: true },
      }
      let etapaEm = this.lotesSelecionados.filter(el => el.etapa == 10 || el.etapa == 25 || el.etapa == 30).length > 0
      if(etapaEm) {
        paramModal.title = "Atenção!"
        paramModal.message = "Lotes no estado em validação  ou em transmissão, <br/> não podem ser excluidos. Verifique a seleção e tente novamente."
        paramModal.callback = () => { this.resetSelected() }
        paramModal.btConfirm = { name: 'Fechar', show: true }
        paramModal.btCancel = { name: 'Cancelar', show: false }
        paramModal.textForm = {  show: false }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        let etapa = this.lotesSelecionados.filter(el => (el.etapa >= 40 && el.proc_trd_tem_erro == 0 && el.env_op_tem_erro == 0) || (el.etapa >= 70 && el.env_op_tem_erro == 1)).length > 0
        if (etapa && !etapaEm) {
          this.bool = 1
          paramModal.title = "Excluir lote?"
          paramModal.message = "Essa exclusão não substitui <br/> a exclusão no sistema da operadora."
          paramModal.messageForm = (text) => {
            let msg = text
            this.deleteLote(id, msg, 1)
          },
          paramModal.textForm = { label: "Por que você está excluindo esse lote?", show: true }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        } else {
          if (this.lotesSelecionados.length != 0) {
            paramModal.title = "Excluir lote?"
            paramModal.message = "Ao excluir, o lote não estará mais disponível no cronograma. <br/> Essa alteração <b>não</b> poderá ser desfeita."
            paramModal.callback = () => { this.deleteLote(id, null, 0) }
            paramModal.textForm = {  show: false }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          }
        }
      }
    },
    associarNota(idNotas, idLotes) {
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "associarnotafiscal",
          Payload: {
            grupo_economico: this.grupoEconomico,
            prestador_id: this.cronogramadata.prestador_id,
            operadora_ans_id: this.cronogramadata.operadora_ans_id,
            cronograma_id: this.cronogramadata.id,
            lotes: idLotes,
            nota_fiscal_id: idNotas
          }
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then(response => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        } 
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.getLotes()
            this.dialog = false
          },
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    deleteLote(id, msg, bool) {
      let prestadorId = this.cronogramadata.prestador_id
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "deletelote",
          Payload: {
            grupo_economico: this.grupoEconomico,
            prestador_id: prestadorId ?prestadorId :1,
            lotes: id,
            justificativa: msg,
            is_justificavel: bool
          }
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then(response => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        } 
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => { 
            this.getLotes() 
            this.getDetalhesCronograma(this.$route.params).then(resp => {
              this.aguardandoConclusao = resp.capa_lote_status == 1 ? true : false
              this.cronogramadata = resp
              this.cronogramadata.grupo_economico= this.grupoEconomico 
              this.cronoLoaded= true
              this.total_lotes = resp.total
            })
          },
          btConfirm: { name: "Ok", show: true },
          btCancel: { show: false }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    selectLote(item) {
      this.resetSelect = false
      this.lotesSelecionados = item
    },
    resetSelected() {
      this.resetSelect = true
    },
    confirmLiberacaoLotes(){
      let paramModal = {
          type: "warning",
          title: "Atenção!",
          message: "Você deseja realmente liberar TODOS os lotes válidos para envio à operadora?",
          callback: () => { this.liberacaoLotes() },
          btConfirm: { name: "Enviar", show: true },
          btCancel: { name: 'Cancelar', show: true }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    liberacaoLotes(){
      let { grupo_economico, id, prestador_id, login_prestador, operadora_ans_id } = this.cronogramadata
      let cronograma_id = id
      let username_alteracao = this.userData.UserName

       let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "liberarenviolotes",
          Payload: {  grupo_economico, cronograma_id, prestador_id, login_prestador, operadora_ans_id, username_alteracao }
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then(response => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        } 
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => { this.getLotes() },
          btConfirm: { name: "Ok", show: true },
          btCancel: { show: false }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    openProtocoloEmMassa() {
      let validation = false;
      this.lotesIdsProtocolo = [];
      if(this.parametros && this.parametros.FAT_ACEITA_XML_INVALIDO){
        validation = this.lotesSelecionados.filter(el => el.etapa < 20 || (el.protocolo_editing_user != null && el.protocolo_editing_user != this.userData.UserName)).length > 0
        this.lotesIdsProtocolo = this.lotesSelecionados.filter(el => ((el.etapa >=20) || el.etapa >= 40) && (el.username_editing == this.userData.UserName || el.username_editing == null|| el.username_editing == '') && (el.protocolo_editing_user == this.userData.UserName || el.protocolo_editing_user == null) && el.env_op_tem_erro == 0).map(el => el.id)
      }
      else 
      {
        validation = this.lotesSelecionados.filter(el => el.etapa < 20 || el.env_op_tem_erro == 1 || (el.protocolo_editing_user != null && el.protocolo_editing_user != this.userData.UserName)).length > 0
        this.lotesIdsProtocolo = this.lotesSelecionados.filter(el => ((el.etapa >=20 && el.proc_trd_tem_erro == 0) || el.etapa >= 40) && (el.username_editing == this.userData.UserName || el.username_editing == null|| el.username_editing == '') && (el.protocolo_editing_user == this.userData.UserName || el.protocolo_editing_user == null) && el.env_op_tem_erro == 0).map(el => el.id)

      }

      if (!validation) {
        this.protocoloEmMassa = true
      } else {
        let outUse = this.lotesSelecionados.filter(el => el.protocolo_editing_user != null && el.protocolo_editing_user != this.userData.UserName)
        this.userProtocoloAlocado = outUse.length ?outUse[0].protocolo_editing_user : null
        let paramModal = {
          type: "info",
          title: "Há lotes selecionados que não podem ser editados!",
          message: "Lotes abertos com outro usuário ou em validação ou rejeitado pela operadora, <br> serão ignorados na seleção de edição em massa de protocolo.<br> Deseja prosseguir?",
          callback: () => { 
            if (this.lotesIdsProtocolo.length == 1) {
              setTimeout(() => {
                let paramModal = {
                  type: "warning",
                  title: "Edição em massa",
                  message: "É necessário mais de 1 lote válido e liberado para edição.  Utilize o ícone de edição de protocolo na própria linha da tabela.",
                  callback: () => { this.getLotes() },
                  btConfirm: { name: "Ok", show: true, color: "warning" },
                  btCancel: { show: false }
                }
                this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
              },100)
            } else {
              this.protocoloEmMassa = true
            }
          },
          btConfirm: { name: "sim", show: true },
          btCancel: { name: "não", show: true }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
    },
    desalocaProtocolo() {
      let grupo_economico = this.cronogramadata.grupo_economico
      let lotes_ids = this.lotesIdsProtocolo
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "desalocaprotocolo",
          Payload: {grupo_economico, lotes_ids}
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then(response => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        } 
        this.lotesIdsProtocolo = []
        this.updateCronogramaData()
        this.getLotes()
        this.protocoloEmMassa = false
      })
    },
    relaGuia(t){      
      let payload = { grupo_economico: this.grupoEconomico, arquivo_id: t.id}
      let obj = {query:[{Modulo: "Recebiveis", Acao: "getrelacaoguias", Payload: payload}]}
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return
        }
        this.relacaoList = response.dados
        this.showRelacao = true
        
      })
    }
  }
}
</script>

<style>

</style>